import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import VariantB from './pages/VariantB/VariantB';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<VariantB />} />
        <Route path="/b" element={<VariantB />} />
        <Route path="/b/*" element={<VariantB />} />
        <Route path="/old" element={<HomePage />} />
      </Routes>
    </Router>
  );
}

export default App;